import { render, staticRenderFns } from "./AddonNew.vue?vue&type=template&id=b48e6aa8&scoped=true&"
import script from "./AddonNew.vue?vue&type=script&lang=js&"
export * from "./AddonNew.vue?vue&type=script&lang=js&"
import style0 from "./AddonNew.vue?vue&type=style&index=0&id=b48e6aa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48e6aa8",
  null
  
)

export default component.exports